import { gql } from "@apollo/client";
import { GenericRow } from "../../../../Components/Tables/_Tables/useColumnConstructor";

export const GET_FEED_COMPONENTS_INFO = gql`
  query FeedComponentInfo($domain: String!, $input: BasicQueryInfoInput!) {
    feedComponent {
      info(domain: $domain, input: $input) {
        id
        name
        readyMixture
        priority
        ds
        energy
        protein
        deleted
      }
    }
  }  
`;

export interface FeedComponentsResponse {
  feedComponent: {
    info: FeedComponentInfo[]
  }
}

export interface BasicQueryInfoInput {
  ids?: number[];
  offset?: number;
  fetchAmount?: number;
}

export interface FeedComponentInfo extends GenericRow {
  id: number;
  name: string;
  readyMixture: boolean;
  priority: number;
  ds: number;
  energy: number;
  protein: number;
  deleted: boolean;
}

export interface FeedComponentInfoForTable extends GenericRow {
  id: number;
  name: string | JSX.Element;
  readyMixture: boolean;
  priority: number;
  ds: number;
  energy: number;
  protein: number;
}